export { default } from './PublicacionsMarato';
